// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-confirm-modal .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.55);
}

.dark-mode .delete-confirm-modal .MuiBackdrop-root,
html.dark-mode .delete-confirm-modal .MuiBackdrop-root {
  background-color: rgba(0, 0, 0, 0.65);
}

.delete-confirm-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(420px, 95%);
  min-height: 148px;
  padding: 24px 20px 20px;
  border-radius: 12px;
  text-align: center;
  background: var(--surface-color, #ffffff);
  color: var(--text-color, #111827);
  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
  outline: none;
}

.light-mode .delete-confirm-dialog,
html.light-mode .delete-confirm-dialog {
  background: #ffffff;
  color: #111827;
  border-color: rgba(15, 23, 42, 0.12);
}

.dark-mode .delete-confirm-dialog,
html.dark-mode .delete-confirm-dialog {
  background: #1e293b;
  color: #f8fafc;
  border-color: rgba(248, 250, 252, 0.14);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.delete-confirm-dialog__title {
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.35;
  margin: 0 0 12px;
  color: inherit;
}

.delete-confirm-dialog__body {
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.45;
  margin: 0 0 20px;
  opacity: 0.88;
}

.delete-confirm-dialog__actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.delete-confirm-dialog__btn {
  flex: 1 1;
  min-height: 40px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),
    filter 0.15s ease, box-shadow 0.15s ease;
}

.delete-confirm-dialog__btn:hover {
  filter: brightness(1.05);
}

.delete-confirm-dialog__btn:active {
  transform: scale(0.98);
}

.delete-confirm-dialog__btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.delete-confirm-dialog__btn--cancel {
  background: transparent;
  color: inherit;
  border-color: var(--border-color, rgba(15, 23, 42, 0.18));
}

.light-mode .delete-confirm-dialog__btn--cancel,
html.light-mode .delete-confirm-dialog__btn--cancel {
  background: #f3f4f6;
  color: #111827;
  border-color: rgba(15, 23, 42, 0.12);
}

.dark-mode .delete-confirm-dialog__btn--cancel,
html.dark-mode .delete-confirm-dialog__btn--cancel {
  background: rgba(248, 250, 252, 0.08);
  color: #f8fafc;
  border-color: rgba(248, 250, 252, 0.16);
}

.delete-confirm-dialog__btn--delete {
  background: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
}

.delete-confirm-dialog__btn--delete:hover {
  background: #b91c1c;
  border-color: #b91c1c;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Aresure.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;EACjC,6DAA6D;EAC7D,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;4CAC0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".delete-confirm-modal .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.55);\n}\n\n.dark-mode .delete-confirm-modal .MuiBackdrop-root,\nhtml.dark-mode .delete-confirm-modal .MuiBackdrop-root {\n  background-color: rgba(0, 0, 0, 0.65);\n}\n\n.delete-confirm-dialog {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(420px, 95%);\n  min-height: 148px;\n  padding: 24px 20px 20px;\n  border-radius: 12px;\n  text-align: center;\n  background: var(--surface-color, #ffffff);\n  color: var(--text-color, #111827);\n  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);\n  outline: none;\n}\n\n.light-mode .delete-confirm-dialog,\nhtml.light-mode .delete-confirm-dialog {\n  background: #ffffff;\n  color: #111827;\n  border-color: rgba(15, 23, 42, 0.12);\n}\n\n.dark-mode .delete-confirm-dialog,\nhtml.dark-mode .delete-confirm-dialog {\n  background: #1e293b;\n  color: #f8fafc;\n  border-color: rgba(248, 250, 252, 0.14);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);\n}\n\n.delete-confirm-dialog__title {\n  font-size: 1.15rem;\n  font-weight: 600;\n  line-height: 1.35;\n  margin: 0 0 12px;\n  color: inherit;\n}\n\n.delete-confirm-dialog__body {\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1.45;\n  margin: 0 0 20px;\n  opacity: 0.88;\n}\n\n.delete-confirm-dialog__actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.delete-confirm-dialog__btn {\n  flex: 1;\n  min-height: 40px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),\n    filter 0.15s ease, box-shadow 0.15s ease;\n}\n\n.delete-confirm-dialog__btn:hover {\n  filter: brightness(1.05);\n}\n\n.delete-confirm-dialog__btn:active {\n  transform: scale(0.98);\n}\n\n.delete-confirm-dialog__btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.delete-confirm-dialog__btn--cancel {\n  background: transparent;\n  color: inherit;\n  border-color: var(--border-color, rgba(15, 23, 42, 0.18));\n}\n\n.light-mode .delete-confirm-dialog__btn--cancel,\nhtml.light-mode .delete-confirm-dialog__btn--cancel {\n  background: #f3f4f6;\n  color: #111827;\n  border-color: rgba(15, 23, 42, 0.12);\n}\n\n.dark-mode .delete-confirm-dialog__btn--cancel,\nhtml.dark-mode .delete-confirm-dialog__btn--cancel {\n  background: rgba(248, 250, 252, 0.08);\n  color: #f8fafc;\n  border-color: rgba(248, 250, 252, 0.16);\n}\n\n.delete-confirm-dialog__btn--delete {\n  background: #dc2626;\n  color: #ffffff;\n  border-color: #dc2626;\n}\n\n.delete-confirm-dialog__btn--delete:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
